/*
 * © 2021 Thoughtworks, Inc.
 */

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  dateRangeText: {
    color: '#979797',
  },
}))

export default useStyles
